// Digits allowed before the decimals in the fields of the calculation window
export const MAX_QUANTITY_DIGITS = 6;
export const MAX_WASTE_PERCENTAGE_DIGITS = 3;
export const MAX_SOCIAL_SECURITY_COST_PERCENTAGE_DIGITS = 2;
